import { Flex } from '@chakra-ui/layout';
import { Modal, ModalContent, ModalOverlay } from '@chakra-ui/modal';
import { Box } from '@chakra-ui/react';
import { Button, MaskInput, TextInput, Unform, CustomIcon } from 'components';
import { memo, useCallback, useState } from 'react';
import { RouteComponentProps } from 'react-router';
import { addHoursBank } from 'services/budgetControl';
import { openNotification } from 'utils/notification';
import { queryToObj } from 'utils/query';
import { addHoursValidationSchema } from 'yupSchemas/budgeControl';
import { colors } from 'theme/colors';

import * as Styles from './styles';

interface IProps {
  open: boolean;
  onClose(): void;
  history: RouteComponentProps['history'];
}

const AddHoursModalComponent = ({ open, onClose, history }: IProps): JSX.Element => {
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = useCallback(
    async (data: { quantidade: string; valor: number; dataExpiracao: string }) => {
      if (data.quantidade === '00:00:00') {
        openNotification('Valor de horas inválido', 'error');

        return;
      } else if (data.quantidade.length !== 9) {
        openNotification('Valor de horas inválido', 'error');
        return;
      }
      try {
        setIsLoading(true);

        const searchData = queryToObj(history.location.search);
        const response = await addHoursBank({
          client: { id: searchData.idCliente ? parseInt(searchData.idCliente as string) : 0 },
          ...data,
        });

        openNotification('Horas adicionadas com sucesso!');

        if (response.status === 200 || response.status === 201) {
          history.push(history.location.pathname + history.location.search);
          onClose();
        }

        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
      }
    },
    [],
  );

  return (
    <Modal isOpen={open} onClose={onClose}>
      <ModalOverlay />

      <ModalContent>
        <Styles.Container>
          <Styles.Header>
            <h1>Adicionar horas</h1>

            <Box
              bg="brand.1300"
              borderRadius="50%"
              fontSize="21px"
              fontWeight="bold"
              display="flex"
              alignItems="center"
              justifyContent="center"
              textAlign="center"
              as="button"
              type="button"
              border="none"
              color="brand.gray300"
              onClick={onClose}
            >
              <CustomIcon size="22px" $noSphere icon="round_close" />
            </Box>
          </Styles.Header>

          <Flex mt="2rem">
            <Unform validationSchema={addHoursValidationSchema} onSubmit={handleSubmit}>
              <TextInput
                height={'3rem'}
                name="quantidade"
                type="text"
                // max={500}
                // mask="float"
                label="Quantidade de Horas"
                placeholder="000:00:00"
                // parseToFloat
                border={`1px solid ${colors.brand.gray500}`}
                maxLength={9}
                onKeyPress={(ev: any) => {
                  const timer = ev.target;
                  if (timer.value.length === 9) {
                    timer.value = timer.value.slice(0, 8);
                  }
                  if (timer.value.length === 3 || timer.value.length === 6) {
                    timer.value += ':';
                  }

                  if (Number(timer.value[4]) > 5) {
                    timer.value = timer.value.slice(0, 4);
                  }
                  if (Number(timer.value[7]) > 5) {
                    timer.value = timer.value.slice(0, 7);
                  }
                  if (Number(timer.value[8])) {
                    timer.value = timer.value.slice(0, 8);
                  }
                }}
              />

              <MaskInput
                height={'3rem'}
                name="valor"
                mask="float"
                label="Valor Monetário"
                placeholder="R$ 0,00"
                parseToFloat
                border={`1px solid ${colors.brand.gray500}`}
              />

              <MaskInput
                height={'3rem'}
                name="dataExpiracao"
                mask="date"
                leftIcon={'calendar'}
                label="Data de Expiração"
                placeholder="Data de expiração"
                parseDate
                border={`1px solid ${colors.brand.gray500}`}
                id="Data de Expiração"
              />

              <Flex mt="1rem">
                <Flex ml="auto" justify={'space-between'} width="100%">
                  <Button type="button" variant="cancel" outline onClick={onClose}>
                    Cancelar
                  </Button>

                  <Button type="submit" isLoading={isLoading}>
                    Salvar
                  </Button>
                </Flex>
              </Flex>
            </Unform>
          </Flex>
        </Styles.Container>
      </ModalContent>
    </Modal>
  );
};

export const AddHoursModal = memo(AddHoursModalComponent);
